export function TypographyDefault() {
  return (
    <p className="font-light leading-relaxed mx-auto text-slate-500 lg:text-lg text-base max-w-3xl">
      The time is now for it to be okay to be great. For being a bright color.
      For standing out. Get ready to experience a new level of performance and functionality.
    </p>
  );
}
